/**
 * The media types REVA sends and receives. Shared between client and reva-pdf so a request header,
 * a Blob and the test that asserts them all spell the same string.
 *
 * Use it wherever *our* code picks the type. A value that arrives from outside — a `Content-Type`
 * response header, the `type` of a file the user picked, a document extension from the Orders-API —
 * stays a plain `string`; compare it against these constants instead of widening the type.
 */
export const MimeType = {
    PDF: "application/pdf",
    JSON: "application/json",
    /** Raw binary body, used for uploads that are not multipart. */
    OCTET_STREAM: "application/octet-stream",
    /** Only as a `Content-Type` of a multipart request; the browser appends the boundary itself. */
    MULTIPART_FORM_DATA: "multipart/form-data",
    XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    XLS: "application/vnd.ms-excel",
    PNG: "image/png",
    JPEG: "image/jpeg",
    SVG: "image/svg+xml",
    TEXT_PLAIN: "text/plain",
    TEXT_HTML: "text/html",
    /**
     * Not a media type but the media range that accepts any: only meaningful in an `Accept` header,
     * never as a `Content-Type` or a Blob type.
     */
    ANY: "*/*",
} as const;

// Value and type intentionally share the name (a valid TS value/type merge);
// the lint rule doesn't model this and would flag it as a redeclaration.
export type MimeType = (typeof MimeType)[keyof typeof MimeType];
